import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Flash } from '@primer/components';
import { InfoIcon, CheckIcon } from '@primer/styled-octicons';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { TranslationsReference } from '../../src/components';
import { H3 } from '@primer/gatsby-theme-doctocat/src/components/heading';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`XEDI.js comes bundled with our Translation packs.`}</p>
    <h2>{`Registration`}</h2>
    <p>{`Our `}<inlineCode parentName="p">{`Translator`}</inlineCode>{` is registered with the application `}<inlineCode parentName="p">{`Container`}</inlineCode>{` as `}<inlineCode parentName="p">{`translator`}</inlineCode>{`.`}</p>
    <p>{`It is also exposed statically.`}</p>
    <h2>{`Usage`}</h2>
    <Flash mdxType="Flash">
    <InfoIcon mr={1} mdxType="InfoIcon" /><InlineCode mdxType="InlineCode">Translator</InlineCode> is available statically, or as a parameter via the <InlineCode mdxType="InlineCode">Container</InlineCode>'s <InlineCode mdxType="InlineCode">resolve()</InlineCode> method.
    Here we will display the static usage, which is no different to the resolved usage.
    </Flash>
    <h3>{`Get Supported languages`}</h3>
    <p>{`Get a list of supported languages.`}</p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const languages = Xedi.Translator.getSupportLanguages(); // [ 'en' ]
`}</code></pre>
    <h3>{`The Underscore Method`}</h3>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default Value`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Case insensitive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parameters`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><InlineCode mdxType="InlineCode">{`[]`}</InlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Array of parameters to pass to `}<InlineCode mdxType="InlineCode">{`Sprintf`}</InlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`language`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><InlineCode mdxType="InlineCode">{`en`}</InlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Uses the `}<InlineCode mdxType="InlineCode">{`language`}</InlineCode>{` configuration value`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Examples`}</strong></p>
    <h4>{`Basic Usage`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`Xedi.Translator._('languages.spanish'); // Spanish
`}</code></pre>
    <h4>{`With Parameters`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// workflows.transition.between = transition between %from and %to
Xedi.Translator._(
    'workflows.transition.between',
    [{ from: 'Stage 1', to: 'Stage 2' }]
); // transition between Stage 1 and Stage 2
`}</code></pre>
    <h4>{`Language override`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`Xedi.Translator._('languages.spanish', [], 'es'); // Espanol
`}</code></pre>
    <h2>{`Translations`}</h2>
    <TranslationsReference mdxType="TranslationsReference" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      